import "./LatestInsights.module.css";
import Header from "@/reusable_sections/Header";
import BlogAndResources from "./sections/BlogAndResources";
import FinalCallToAction from "./sections/FinalCallToAction";
import Footer from "@/reusable_sections/Footer";
export default function LatestInsightsPage() {
  return <div>
      <Header />
      <BlogAndResources />
      <FinalCallToAction />
      <Footer />
    </div>;
}